var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 23.9861 5.851 30.6053 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8887 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1074C19.1199 10.5 18.5 11.7333 18.5 12.9986V16H22.9375L22.2281 20.625H18.5V31.8056C26.1491 30.6053 32 23.9861 32 16Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M22.2281 20.625L22.9375 16H18.5V12.9986C18.5 11.7333 19.1198 10.5 21.1074 10.5H23.125V6.5625C23.125 6.5625 21.2939 6.25 19.5434 6.25C15.8887 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.3146 31.9334 15.1495 32 16 32C16.8505 32 17.6854 31.9334 18.5 31.8056V20.625H22.2281Z","fill":"#0e2a40","key":1})]);
}

Fb.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Fb;

Fb.default = Fb;
